var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"yplus-button-row",class:{
   'bg-gray':_vm.gray
},style:(_vm.fixed?'padding-bottom:calc(50px + 2vw)':'')},[_c('div',{staticClass:"yplus-button-row ",class:{
      'button-fixed':_vm.fixed,
      'bg-white':_vm.white,
    }},[_c('van-button',{staticClass:"van-button-new",attrs:{"disabled":_vm.disabled,"native-type":_vm.nativeType,"color":_vm.color,"block":""},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(_vm._s(_vm.text))])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0efe5e1e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/YButton.vue
// module id = null
// module chunks = 